import React from 'react';
import "./HomeSectionTitle.scss";

const HomeSectionTitle = ({text}) => {
	return (
		<h2 className="home-section-title">{text}</h2>
	);
};

export default HomeSectionTitle;